import { FormDataUpload } from '../../nest-api';
import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from 'rxjs/Rx';

@Injectable()
export class PayrollHistoryProvider {

    private readonly _service: string = 'payroll';
    private readonly _model: string = 'PayrollHistoryServices';

    constructor(private nestApiProvider: NestApiProvider) { }

    public getPaidPayroll(): Observable<any> {
        const _method: string = 'GET';
        const _func: string = 'paidPayroll';
        const _params: any = {};
        const _urlParams: any = {};
        const _body: any = {};

        const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
        return this.nestApiProvider.request(_method, _url, _func, _params, _body);
    }

    public uploadHistory(data, periodCode: any): Observable<any> {
        const _method: string = 'POST';
        const _func: string = 'uploadHistory';
        const _params: FormDataUpload[] = [];
        _params.push(
            { name: 'files', value: data },
            { name: 'periodCode', value: periodCode }
        );
        const _urlParams: any = {};

        const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
        return this.nestApiProvider.requestUpload(_method, _url, _params);
    }

    public payrollHistory(param: any): Observable<any> {
        const _method: string = 'GET';
        const _func: string = 'payrollHistory';
        const _params: any = {};
        const _urlParams: any = {};
        const _body: any = {};

        if (typeof param !== 'undefined' && param !== null) _urlParams.params = param;

        const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
        return this.nestApiProvider.requestBlob(_method, _url, _func, _params, _body);
    }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/payroll-history/payroll-history-provider.ts